import { Close } from '@icon-park/react'
import { HoverTooltip } from '../Tooltip'
import { Container, RemoveButton, TagItem, TagText, NoTagsText, MoreTagsIndicator } from './TagsList.styles'

export interface TagsListItem {
  id: string
  text: string
  tooltip?: string
  removable?: boolean
}

interface TagsListProps {
  tags: TagsListItem[]
  maxVisible?: number
  emptyText?: string
  variant?: 'default' | 'compact' | 'preview'
  className?: string
  fullText?: boolean
  onRemove?: (tag: TagsListItem) => void
}

export function TagsList({
  tags,
  maxVisible = 3,
  emptyText = 'Nenhuma tag definida',
  variant = 'default',
  className,
  fullText = false,
  onRemove,
}: TagsListProps): JSX.Element {
  if (tags.length === 0) {
    return <NoTagsText className={className}>{emptyText}</NoTagsText>
  }

  const visibleTags = tags.slice(0, maxVisible)
  const remainingTags = tags.slice(maxVisible)
  const remainingCount = remainingTags.length

  const tooltipContent =
    remainingCount > 0 ?
      <div style={{ maxWidth: '400px', minWidth: '300px' }}>
        <div style={{ fontWeight: '600', marginBottom: '8px', fontSize: '13px' }}>
          Termos ocultos ({remainingCount}):
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
            maxHeight: '200px',
            overflowY: 'auto',
          }}>
          {remainingTags.map((tag) => (
            <span
              key={tag.id}
              style={{
                fontSize: '12px',
                backgroundColor: '#f0f0f0',
                padding: '3px 8px',
                borderRadius: '4px',
                display: 'inline-block',
                lineHeight: '1.4',
              }}>
              {tag.text}
            </span>
          ))}
        </div>
      </div>
    : null

  return (
    <Container $variant={variant} className={className}>
      {visibleTags.map((tag) => (
        <TagItem key={tag.id} $variant={variant} $fullText={fullText}>
          <TagText $fullText={fullText} title={tag.tooltip ?? tag.text}>
            {tag.text}
          </TagText>
          {onRemove && tag.removable !== false && (
            <RemoveButton
              type="button"
              aria-label={`Remover ${tag.text}`}
              onClick={(event) => {
                event.stopPropagation()
                onRemove(tag)
              }}>
              <Close size={10} />
            </RemoveButton>
          )}
        </TagItem>
      ))}
      {remainingCount > 0 && (
        <HoverTooltip value={tooltipContent} disabled={!tooltipContent}>
          <MoreTagsIndicator $variant={variant}>
            <TagText>...</TagText>
          </MoreTagsIndicator>
        </HoverTooltip>
      )}
    </Container>
  )
}
